import React from "react";
import { BoxProps, useTheme } from "@mui/material";
import Box from "components/Box/Box";
import { objectivePalette } from "styles/objectivePalette";
import { UserAvatarType } from "components/UserAvatar/UserAvatar.types";
import { styled } from "@mui/material/styles";
import { css } from "@emotion/react";

type Props = BoxProps & {
  initials: string;
  rectSize: number;
  fontSize: number;
  charLimit?: number;
  type?: UserAvatarType;
  disabled?: boolean;
};

const UserAvatar: React.FC<Props> = ({
  initials,
  rectSize,
  fontSize,
  charLimit = 2,
  type = UserAvatarType.Solid,
  disabled = false,
  ...boxProps
}) => {
  const theme = useTheme();

  const avatar = React.useMemo(() => {
    switch (type) {
      case UserAvatarType.Solid:
        if (disabled) {
          return { border: "none", bgcolor: theme.palette.grey[600], color: theme.palette.paper?.main };
        }
        return { border: "none", bgcolor: theme.palette.primary.main, color: theme.palette.paper?.main };
      case UserAvatarType.Outlined:
        if (disabled) {
          return {
            border: `2px solid ${theme.palette.grey[600]}`,
            bgcolor: "transparent",
            color: theme.palette.grey[600],
          };
        }
        return {
          border: `2px solid ${theme.palette.primary.main}`,
          bgcolor: "transparent",
          color: theme.palette.primary.main,
        };
      case UserAvatarType.Dimmed:
        return {
          border: "none",
          bgcolor: `${objectivePalette.light.allspice}`,
          color: `${objectivePalette.dark.night}`,
        };
    }
  }, [type, disabled, theme]);

  // TODO: Refactor - get rid of Box for detailed styling, use styled-components instead
  return (
    <StyledBox
      width={rectSize}
      height={rectSize}
      borderRadius={rectSize}
      border={avatar.border}
      bgcolor={avatar.bgcolor}
      color={avatar.color}
      display="flex"
      justifyContent="center"
      alignItems="center"
      fontWeight={600}
      fontSize={fontSize}
      {...boxProps}
    >
      {initials?.slice(0, charLimit) || "?"}
    </StyledBox>
  );
};

export default UserAvatar;

const StyledBox = styled(Box)(
  ({ theme }) => css`
    font-weight: 600;
  `
);
